import {User} from 'lucide-react';
import {useIntl} from 'react-intl';
import {DsAvatar} from 'ch3-ui-lib';
import type {Call} from '../../../store/features/calls/callsService';
import {getFormatedPhoneNumber} from '../../../utilis/msisdnUtilis';
import {NumberFlag} from '../callParts';
import {insightsMessages as m} from './insightsMessages';
import {lucide} from './insightsUi';
import {isVoicemailCall} from './insightsModel';
import type {Speaker, SpeakerCast} from './transcript/speakers';

const numberChip = 'inline-flex h-6 max-w-full items-center gap-1.5 rounded-chip bg-surface-muted px-2.5 text-footnote font-medium tabular-nums text-ink';

const Party = ({speaker, msisdn, label}: {speaker: Speaker; msisdn?: number | null; label?: string | null}) => (
    <div className="flex min-w-0 flex-1 flex-col items-center gap-1 text-center">
        <DsAvatar
            size={36}
            name={speaker.known ? speaker.name : ''}
            src={speaker.avatarUrl}
            palette={speaker.palette}
            icon={speaker.known ? undefined : <User size={18} aria-hidden="true" className={lucide}/>}
        />
        <span className="max-w-full truncate text-callout font-semibold text-ink">{speaker.name}</span>
        {msisdn ? (
            <span className={numberChip}>
                <NumberFlag msisdn={msisdn} size={14}/>
                <span className="truncate">{label ? `${label} · ` : ''}{getFormatedPhoneNumber(msisdn, true)}</span>
            </span>
        ) : null}
    </div>
);

export const InsightsParticipants = ({call, cast}: {call: Call; cast: SpeakerCast}) => {
    const intl = useIntl();
    const pill = isVoicemailCall(call)
        ? m.voicemailFor
        : call.forwardedTo ? m.forwardedTo : call.type === 'OUTBOUND' ? m.calledBy : m.handledBy;
    const clientNumber = call.primaryContact ? call.clientMsisdn : null;
    const agentNumber = call.forwardedTo ? null : call.exposedMsisdn?.msisdn ?? null;

    return (
        <div className="flex items-start gap-3" data-testid="insights-participants">
            <Party speaker={cast.client} msisdn={clientNumber}/>
            <span className="mt-1.5 inline-flex h-6 shrink-0 items-center rounded-chip bg-brand-tint px-2.5 text-footnote font-semibold text-brand-ink">
                {intl.formatMessage(pill)}
            </span>
            <Party speaker={cast.agent} msisdn={agentNumber} label={call.forwardedTo ? null : call.exposedMsisdn?.label}/>
        </div>
    );
};
